import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {HttpService} from '../../../services/apiServices/http-service.service';
import {VirtualPrinterService} from '../../../services/apiServices/business/virtual-printer.service';
import {TranslateService} from '@ngx-translate/core';
import {FileSaverService} from 'ngx-filesaver';
import {CommonService} from '../../../services/apiServices/business/common.service';

@Component({
  selector: 'app-download-generic-form',
  templateUrl: './download-generic-form.component.html',
  styleUrls: ['./download-generic-form.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DownloadGenericFormComponent implements OnInit {
  @Input()
  public releaseValue: string;
  @Output()
  public displayFormToDownload: EventEmitter<boolean>;
  public data: any;
  public serverMode: boolean;
  public showPrinterGUI: boolean;
  public showSelectChain: boolean;
  public showSelectDistriMode: boolean;
  public displayPDF: boolean;
  public archList: Array<object>;
  public arch: string;
  public envList: Array<object>;
  public env: string;
  public localeList: Array<object>;
  public locale: string;
  public uploadFormatList: Array<object>;
  public uploadFormat: string;
  public useProxy: boolean;
  public proxyAuth: boolean;
  public proxyHost: string;
  public proxyPort: string;
  public proxyPAC: string;
  public proxyUserName: string;
  public proxyUserPassword: string;
  public downloadGenericMessages: any;
  public downloadGenericOK: boolean;
  public proxyTypes: Array<{ label, value }>;
  public proxyType: any;
  public regexp: Map<string, RegExp>;
  public pac_host_port: string;
  public host_port: string;
  public login_mdp: string;
  public pac_format_error: string;
  public host_format_error: string;
  public port_format_error: string;

  constructor( public httpService: HttpService, private commonService: CommonService,
               private fileSaverService: FileSaverService,
               private virtualPrinterService: VirtualPrinterService,  private translate: TranslateService) {
    this.getTraductions();

    this.data = {};
    this.serverMode = false;
    this.showPrinterGUI = true;
    this.showSelectChain = true;
    this.showSelectDistriMode = false;
    this.displayPDF = true;
    this.archList = [
      { label: 'x32', value: 'x32' },
      { label: 'x64', value: 'x64' }
    ];
    this.arch = 'x64';
    this.envList = [
      { label: 'Recette', value: 'Rec' },
      { label: 'Production', value: 'Prod' }
    ];
    this.env = 'Rec';
    this.localeList = [
      { label: 'fr', value: 'fr' },
      { label: 'en', value: 'en' }
    ];
    this.locale = 'fr';
    this.uploadFormatList = [
      { label: 'pdf', value: 'pdf' },
      { label: 'ps', value: 'ps' }
    ];
    this.uploadFormat = 'pdf';
    this.useProxy = false;
    this.proxyAuth = false;
    this.proxyHost = '';
    this.proxyPort = undefined;
    this.proxyPAC = '';
    this.proxyUserName = undefined;
    this.proxyUserPassword = undefined;

    this.initErrorMessages();

    this.downloadGenericOK = false;
    this.displayFormToDownload = new EventEmitter<boolean>();

    this.proxyTypes = [
      { label: 'Statique', value: 'statique' },
      { label: 'Dynamique', value: 'dynamique' }
    ];

    this.proxyType = 'statique';

    this.regexp = new Map([
      [ 'ip', /^[\d]{1,3}\.[\d]{1,3}\.[\d]{1,3}\.[\d]{1,3}$/gim ],
      // tslint:disable-next-line:max-line-length
      [ 'url', /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/gi ],
      [ 'hostname', /^([a-zA-Z0-9](?:(?:[a-zA-Z0-9-]*|\.(?![-.]))*[a-zA-Z0-9]+))$/ ],
      [ 'number', /^\d+$/]
    ]);
  }

  public getTraductions(): void {
    this.translate.get('VIRTUAL_PRINTER.ERRORS.PAC_HOST_PORT' ).subscribe((res: string) => {
      this.pac_host_port = res;
    });
    this.translate.get('VIRTUAL_PRINTER.ERRORS.HOST_PORT').subscribe((res: string) => {
      this.host_port = res;
    });
    this.translate.get('VIRTUAL_PRINTER.ERRORS.LOGIN_MDP').subscribe((res: string) => {
      this.login_mdp = res;
    });
    this.translate.get('VIRTUAL_PRINTER.ERRORS.PAC_FORMAT_ERROR' ).subscribe((res: string) => {
      this.pac_format_error = res;
    });
    this.translate.get('VIRTUAL_PRINTER.ERRORS.HOST_FORMAT_ERROR' ).subscribe((res: string) => {
      this.host_format_error = res;
    });
    this.translate.get('VIRTUAL_PRINTER.ERRORS.PORT_FORMAT_ERROR' ).subscribe((res: string) => {
      this.port_format_error = res;
    });
  }

  public initErrorMessages(): void {
    this.downloadGenericMessages = {
      errors: [{
        error: 'pac_host_port',
        active: false,
        message: this.pac_host_port
      }, {
        error: 'host_port',
        active: false,
        message: this.host_port
      }, {
        error: 'login_mdp',
        active: false,
        message: this.login_mdp
      }, {
        error: 'pac_format_error',
        active: false,
        message: this.pac_format_error
      }, {
        error: 'host_format_error',
        active: false,
        message: this.host_format_error
      }, {
        error: 'port_format_error',
        active: false,
        message: this.port_format_error
      }],
      success: {
        active: true,
        message: 'Aucun problèmes détectés'
      }
    };
  }
  public ngOnInit(): void { }

  public setEnv( event ) {
    this.env = event.value;
  }

  public setArch( event ) {
    this.arch = event.value;
  }

  public setLocale( event ) {
    this.locale = event.value;
  }

  public setUploadFormat( event ) {
    this.uploadFormat = event.value;
  }

  public checkRegExp( event, error, reg ): void {

    const value = event.target.value,
      isValid = reg.test( event.target.value );


    if ( value && !isValid ) {
      this.downloadGenericMessages.errors.forEach(el => {
        if (el.error === error ) {
          el.active = true;
        }
      });
    } else {
      this.downloadGenericMessages.errors.forEach(el => {
        if (el.error === error) {
          el.active = false;
        }
      });
    }
    this.checkErrors();
  }

  public HostProxyChange(): void {
    if ( ( this.proxyHost && !this.proxyPort ) || ( !this.proxyHost && this.proxyPort ) ) {
      this.downloadGenericMessages.errors.forEach(el => {
        if (el.error === 'host_port') {
          el.active = true;
        }
      });
    } else {
      this.downloadGenericMessages.errors.forEach(el => {
        if (el.error === 'host_port') {
          el.active = false;
        }
      });
    }
    this.checkErrors();
  }

  public checkHostNameFormat( event ) {

    this.HostProxyChange();

    const value = event.target.value,
      ipValid = this.regexp.get( 'ip' ).test( value ),
      hostNameValid = this.regexp.get( 'hostname' ).test( value );


    if ( !ipValid && !hostNameValid ) {
      this.downloadGenericMessages.errors.forEach(el => {
        if (el.error === 'host_format_error') {
          el.active = true;
          this.downloadGenericMessages.success.active = false;
        }
      });
    } else {
      this.downloadGenericMessages.errors.forEach(el => {
        if (el.error === 'host_format_error') {
          el.active = false;
        }
      });
    }
    this.checkErrors();
  }

  public loginPassword( event ): void {

    if ( ( this.proxyUserName && !this.proxyUserPassword ) || ( !this.proxyUserName && this.proxyUserPassword ) ) {
      this.downloadGenericMessages.errors.forEach(el => {
        if (el.error === 'login_mdp') {
          el.active = true;
          this.downloadGenericMessages.success.active = false;
        }
      });
    } else {
      this.downloadGenericMessages.errors.forEach(el => {
        if (el.error === 'login_mdp') {
          el.active = false;
        }
      });
    }
    this.checkErrors();
  }

  public checkErrors(): boolean {

    this.downloadGenericMessages.success.active = this.downloadGenericMessages.errors.every(el => el.active === false);

    return this.downloadGenericMessages.success.active;
  }

  public resetDownloadGenericVirtualPrinter( event ): void {
  }

  public unsetDisplayFormToDownload( event ) {
    this.displayFormToDownload.emit( false );
  }

  public downloadGenericVirtualPrinter( event ): void {

    const that = this;

    this.data = {
      release: this.releaseValue,
      architecture: this.arch,
      environment: this.env,
      locale: this.locale,
      uploadFormat: this.uploadFormat,
      serverMode: this.serverMode,
      showSelectChain: this.showSelectChain,
      showSelectDistriMethod: this.showSelectDistriMode,
      displayPDF: this.displayPDF,
      showPrinterGUI: this.showPrinterGUI,
      useProxy: this.useProxy,
      proxyAuth: this.proxyAuth
    };

    if ( this.useProxy ) {
      if ( this.proxyPAC ) {
       this.data.proxyPAC = this.proxyPAC;
      } else {
        if ( this.proxyHost ) {
          this.data.proxyHost = this.proxyHost;
        }
        if ( this.proxyPort ) {
          this.data.proxyPort = this.proxyPort;
        }
      }

      if ( this.proxyAuth ) {
        if ( this.proxyUserName ) {
          this.data.proxyUser = this.proxyUserName;
        }
        if ( this.proxyUserPassword ) {
          this.data.proxyPass = this.proxyUserPassword;
        }
      }
    }

    if ( this.checkErrors() ) {
      this.virtualPrinterService.downloadVirtualPrinter( this.data ).subscribe( response => {
        const h = response.headers.get('content-type');

        if (h.startsWith('application/zip')) {
          if (response.body.size > 0) {
            const fileName = response.headers.get('content-disposition').split(';')[1].split('=')[1];
            const blob = new Blob([ response.body ], {endings: 'native', type: response.headers.get('content-type')});
            this.fileSaverService.save(blob, fileName);
          } else {
            this.commonService.addToast({
              life: 5000,
              severity: 'error',
              summary: 'Téléchargement',
              detail: response.sMsgError
            });
          }
        } else if (h.startsWith('application/json')) {

          const reader = new FileReader();

          reader.onload = (e: any) => {
            const msg = JSON.parse(( e.target ).result);

            this.commonService.addToast({
              life: 5000,
              severity: 'error',
              summary: 'Téléchargement',
              detail: msg.sMsgError
            });
          };

          reader.readAsText(response.body);
        }
      });
    }
  }
}
